










export enum FixedCommentEntityTypeEnum {

	Session = "FC_ENTITY_TYPE_SESSION",

	Test = "FC_ENTITY_TYPE_TEST",

	Alerts = "FC_ENTITY_TYPE_ALERTS",

}